import TeacherPortalQuiz from "./quiz/Quiz";
import { NavLink } from "react-router-dom";
import { AiOutlineContacts, AiOutlineHome, AiOutlineUserSwitch } from "react-icons/ai";
import { useEffect, useState } from "react";
import Icon from "../general/Icon";
import TeacherPortalLearningMaterials from "./learning_materials/LearningMaterials";
import TeacherPortalCourseDashboard from "./course/CourseDashboard";
import TeacherPortalStudents from "./students/Students";

const TeacherPortalSidebarNavigation = ({ course, activities, activitiesWithUsageData, setSelectedPage, quizesInformation, activitiesWithUsageDataGroupedByType, userEvents, loadMoreUserEvents, students, constructScores }) => {
    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        const dashboardPage = <TeacherPortalCourseDashboard activitiesWithUsageDataGroupedByType={activitiesWithUsageDataGroupedByType} quizesInformation={quizesInformation} userEvents={userEvents} loadMoreUserEvents={loadMoreUserEvents} constructScores={constructScores} />;
        setMenuItems([
            { name: "General", items: [
                { name: "Student view", icon: <AiOutlineUserSwitch size={30} color={"black"} />, link: "/course/" + course.courseid },
                { name: "Dashboard", icon: <AiOutlineHome size={30} color={"black"} />, component: dashboardPage }
            ] },
            { name: "Quizes", items: activities != undefined ? activities.filter(a => a.activitytype == "learning_material_quiz").map((activity) => ({
                name: activity.activitytitle,
                icon: <Icon type={activity.activitytype} color="black" />,
                component: <TeacherPortalQuiz quizInformation={quizesInformation.find((a) => a.activityid == activity.activityid)} />
            })) : [] },
            { name: "Learning Material", items: [{
                icon: <Icon type="learning_material_paws_reading" color="black" />,
                name: "All Learning materials",
                component: <TeacherPortalLearningMaterials activitiesWithUsageData={activitiesWithUsageData} course={course} />
            }].concat(activities.filter(() => false).filter(a => a.activitytype != "learning_material_quiz").map((activity) => ({
                name: activity.activitytitle,
                icon: <Icon type={activity.activitytype} color="black" />,
                component: "/course/" + course.courseid + "/teacher_portal/learning_material/" + activity.activityid
            }))) },
            { name: "Students", items: [{
                icon: <AiOutlineContacts size={30} color={"black"} />,
                name: "All Students",
                component: <TeacherPortalStudents students={students} quizesInformation={quizesInformation} activities={activities} activitiesWithUsageData={activitiesWithUsageData} />
            }] }
        ]);
        setSelectedPage(dashboardPage);
    }, [course, activities, activitiesWithUsageData, quizesInformation, activitiesWithUsageDataGroupedByType, userEvents, loadMoreUserEvents, constructScores]);

    return (
        <nav aria-label="Teacher portal" className="text-txt_primary">
            {menuItems.map((menuItem) => (
                <section key={menuItem.name} className="border-b border-card_dark py-5">
                    <h2 className="mb-2 px-4 text-left text-lg font-bold">{menuItem.name}</h2>
                    <ul>
                        {menuItem.items.map((menuSubItem, index) => {
                            const itemContents = (
                                <span className="grid w-full grid-cols-[2fr_10fr] items-center gap-2 text-left">
                                    <span className="flex items-center">{menuSubItem.icon}</span>
                                    <span>{menuSubItem.name}</span>
                                </span>
                            );
                            const key = `${menuItem.name}-${menuSubItem.name}-${index}`;
                            return (
                                <li key={key}>
                                    {menuSubItem.component ? (
                                        <button type="button" className="w-full px-4 py-3 hover:bg-card focus-visible:outline focus-visible:outline-2 focus-visible:outline-link" onClick={() => setSelectedPage(menuSubItem.component)}>
                                            {itemContents}
                                        </button>
                                    ) : (
                                        <NavLink to={menuSubItem.link} className="block px-4 py-3 hover:bg-card focus-visible:outline focus-visible:outline-2 focus-visible:outline-link">
                                            {itemContents}
                                        </NavLink>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </section>
            ))}
        </nav>
    );
};

export default TeacherPortalSidebarNavigation;